<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-none element-without-heading" id="uncategorized-2">
<div class="text" id="uncategorized-2-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><b>From the <i>New York Times</i> bestselling author of <i>Ink</i>, the Rot and Ruin series,</b></p>
<p class="alignment-block-content alignment-block-content-center"><b>and the creator of <i>V-Wars</i>.</b></p>
<p class="alignment-block-content alignment-block-content-center"><b>The undead walk. Vicious, relentless,</b></p>
<p class="alignment-block-content alignment-block-content-center"><b>and never tiring.</b></p>
</div>
</div>
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><i>Hungry.</i></p>
<p class="alignment-block-content alignment-block-content-left">And the dead have their stories.</p>
<p class="alignment-block-content alignment-block-content-left">Bram Stoker Award winner Jonathan Maberry is a master of the zombie tale. <i>Empty Graves: Tales of the Living Dead </i>is emotionally charged and disturbing. These stories range across the genres of horror, science fiction, and biological thriller without ever straying from the fascinating humanity at the core.</p>
<p class="alignment-block-content alignment-block-content-left">Together in a single action-packed collection, these 15 gritty tales of the living dead span Maberry’s career, including an exclusive never-before-published short story.</p>
</div>
</div>
<hr class="implicit-break"/>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><b>Read them now. <i>If you dare.</i></b></p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// book-description.vue?afbaac7e